<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="会员等级:">
              <el-input v-model.trim="formInlineTmp.level" placeholder="请输入会员等级" type="number" min="0" style="line-height: 60px;"></el-input>
            </el-form-item>
            <el-form-item label="等级名称:">
              <el-input v-model.trim="formInlineTmp.level_title" placeholder="请输入等级名称" type="text" style="line-height: 60px;"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="addGradeDialog = true" class="add-btn" style="float: right;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="addGradeDialog = true">新建</span></div>
        </template>
        <el-table-column label="会员等级" align="center">
          <template slot-scope="scope">
            {{ scope.row.level }}
          </template>
        </el-table-column>
        <el-table-column label="等级名称">
          <template slot-scope="scope">
            {{ scope.row.level_title }}
          </template>
        </el-table-column>
        <el-table-column label="最低分值(>)">
          <template slot-scope="scope">
            {{ scope.row.min }}
          </template>
        </el-table-column>
        <el-table-column label="最高分值(<=)">
          <template slot-scope="scope">
            {{ scope.row.max }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <div class="op-link editColor" @click="editGradeAction(scope.row.id)">
              编辑
            </div>
            <div class="op-link deleteColor" @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog class="cellDialog base-dialog" title="添加等级" :visible.sync="addGradeDialog" width="550px">
        <el-form :model="addGradeForm" label-width="110px" ref="addGradeForm" :rules="rules">
          <el-form-item label="会员等级" prop="level">
            <el-input v-model="addGradeForm.level" placeholder="请输入会员等级(数字)" type="number" min="0"></el-input>
          </el-form-item>
          <el-form-item label="等级名称" prop="level_title">
            <el-input v-model="addGradeForm.level_title" placeholder="请输入等级名称" ></el-input>
          </el-form-item>
          <el-form-item label="最低分值(>)" prop="min">
            <el-input v-model="addGradeForm.min" placeholder="请输入最低分值(数字)" type="number" min="0"></el-input>
          </el-form-item>
          <el-form-item label="最高分值(<=)" prop="max">
            <el-input v-model="addGradeForm.max" placeholder="请输入最高分值(数字)" type="number" min="0"></el-input>
          </el-form-item>
          <el-form-item label="固定权益" prop="rights">
            <el-input v-model="addGradeForm.rights" :autosize="{ minRows: 2, maxRows: 3}" placeholder="请输入固定权益描述" type="textarea" maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="closeAddDialogAction">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addGradeForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog class="cellDialog base-dialog" title="修改等级" :visible.sync="editGradeDialog" width="550px">
        <el-form :model="editGradeForm" label-width="110px"  ref="editGradeForm" :rules="rules" >
          <el-form-item label="会员等级" prop="level">
            <el-input v-model="editGradeForm.level" placeholder="请输入会员等级(数字)" type="number" min="0"></el-input>
          </el-form-item>
          <el-form-item label="等级名称" prop="level_title">
            <el-input v-model="editGradeForm.level_title" placeholder="请输入等级名称"></el-input>
          </el-form-item>
          <el-form-item label="最低分值(>)" prop="min">
            <el-input v-model="editGradeForm.min" placeholder="请输入最低分值(数字)" type="number" min="0"></el-input>
          </el-form-item>
          <el-form-item label="最高分值(<=)" prop="max">
            <el-input v-model="editGradeForm.max" placeholder="请输入最高分值(数字)" type="number" min="0"></el-input>
          </el-form-item>
          <el-form-item label="固定权益" prop="rights">
            <el-input v-model="editGradeForm.rights" :autosize="{ minRows: 2, maxRows: 3}" placeholder="请输入固定权益描述" type="textarea" maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="editGradeDialog = false">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitconfirmGradeForm('editGradeForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { getYzGrade, deleteYzGrade, createYzGrade, getYzGradeDetail, editYzGrade } from '@/api/applet.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
      formInlineTmp:{},
      formInline: {
        level:0,
      },
      options: [],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
      addGradeForm: {
        level_title: '',
        level: '',
        min: '',
        max: ''
      },
      editGradeForm: {
        level_title: '',
        level: '',
        min: '',
        max: ''
      },
      editId: '',
      editGradeDialog: false,
      addGradeDialog: false,
      rules: {
        level: [
          { required: true, message: '请输入会员等级', trigger: 'blur' }
        ],
        level_title: [
          { required: true, message: '请输入等级名称', trigger: 'blur' }
        ],
        min: [
          { required: true, message: '请输入最低分值', trigger: 'blur' }
        ],
        max: [
          { required: true, message: '请输入最高分值', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      //console.log('handleCurrentChangethis.formInline', this.formInline)
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getYzGrade(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    closeAddDialogAction() {
      this.addGradeDialog = false
      this.resetForm()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (parseInt(this.addGradeForm.max) < parseInt(this.addGradeForm.min)) {
            _g.toastMsg('error', '最高分不得小于最低分')
            return
          }
          this.addGradeAction()
        } else {
          return false
        }
      })
    },
    // 请求会员等级详情
    editGradeAction(id) {
      this.editGradeDialog = true
      this.editId = id
      getYzGradeDetail(id).then(res => {
        this.editGradeForm = res.data.data
      })
    },
    submitconfirmGradeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (parseInt(this.editGradeForm.max) < parseInt(this.editGradeForm.min)) {
            _g.toastMsg('error', '最高分不得小于最低分')
            return
          }
          this.confirmGradeAction()
        } else {
          return false
        }
      })
    },
    // 修改会员等级
    confirmGradeAction() {
      editYzGrade(this.editId, this.editGradeForm).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.editGradeDialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    // 添加会员等级
    addGradeAction() {
      createYzGrade(this.addGradeForm).then(res => {
        if (res.data.code === 0) {
          this.addGradeDialog = false
          _g.toastMsg('success', res.data.error)
          this.getData()
          this.resetForm()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.getData()
    },
    resetForm() {
      this.addGradeForm = {
        level_title: '',
        level: '',
        min: '',
        max: ''
      }
    },
    // 删除
    deleteAction(id) {
      this.$confirm('确认删除该会员等级吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteYzGrade(id).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>

</style>
